var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasItems
    ? _c(
        "div",
        { staticClass: "d-flex gap-1 flex-wrap" },
        _vm._l(_vm.brands, function (brand) {
          return _c(
            "el-tag",
            { key: brand.id, attrs: { size: "small", type: "info" } },
            [_vm._v("\n    " + _vm._s(brand.title) + "\n  ")]
          )
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }